import React, { useMemo } from "react";
import PropTypes from "prop-types";

function collectConflicts(agents = []) {
  const keyMap = {};

  const getMappingRules = agent => {
    if (Array.isArray(agent.attribute_mappings) && agent.attribute_mappings.length > 0) {
      return agent.attribute_mappings;
    }

    const legacyTemplate = agent.attribute_mapping_template || {};
    return Object.keys(legacyTemplate).map(targetKey => ({
      source_key: legacyTemplate[targetKey],
      target_key: targetKey,
      transform: null
    }));
  };

  agents.forEach(agent => {
    const mappingRules = getMappingRules(agent);
    mappingRules.forEach(rule => {
      const targetKey = rule.target_key;
      if (!targetKey) {
        return;
      }
      if (!keyMap[targetKey]) {
        keyMap[targetKey] = [];
      }
      keyMap[targetKey].push(agent.name);
    });
  });

  return Object.entries(keyMap)
    .filter(entry => entry[1].length > 1)
    .map(entry => ({ key: entry[0], agents: entry[1] }));
}

export default function BindingConflictPanel({ agents }) {
  const conflicts = useMemo(() => collectConflicts(agents), [agents]);

  if (conflicts.length === 0) {
    return (
      <div style={{ color: "#166534", marginTop: 8 }}>
        No mapping conflicts detected.
      </div>
    );
  }

  return (
    <div style={{ marginTop: 8 }}>
      <div style={{ color: "#9a3412", marginBottom: 6 }}>
        Conflicts detected for the following attribute keys:
      </div>
      {conflicts.map(conflict => (
        <div key={conflict.key} style={{ marginBottom: 6 }}>
          <strong>{conflict.key}</strong>: {conflict.agents.join(", ")}
        </div>
      ))}
    </div>
  );
}

BindingConflictPanel.propTypes = {
  agents: PropTypes.array
};
